import React from 'react';

export default function IconTradingLogout() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_674_33422)">
        <path
          d="M13.625 19.5645H6.875C6.4625 19.5645 6.125 19.227 6.125 18.8145V5.31445C6.125 4.90195 6.4625 4.56445 6.875 4.56445H13.625"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.625 12.0645H19.625"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.625 8.46484L19.625 12.0648L16.625 15.6648"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_674_33422">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(3.125 3.06445)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
